import { render, staticRenderFns } from "./VerifyMail.vue?vue&type=template&id=620b398a&scoped=true&"
import script from "./VerifyMail.vue?vue&type=script&lang=js&"
export * from "./VerifyMail.vue?vue&type=script&lang=js&"
import style0 from "./VerifyMail.vue?vue&type=style&index=0&id=620b398a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620b398a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('620b398a')) {
      api.createRecord('620b398a', component.options)
    } else {
      api.reload('620b398a', component.options)
    }
    module.hot.accept("./VerifyMail.vue?vue&type=template&id=620b398a&scoped=true&", function () {
      api.rerender('620b398a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/VerifyMail.vue"
export default component.exports